import {
  GROUPS_BATCH_DELETE_REQUEST,
  GROUPS_BATCH_DELETE_SUCCESS,
  GROUPS_BATCH_DELETE_FAILURE,
  GROUPS_FETCH_MANY_REQUEST,
  GROUPS_FETCH_MANY_SUCCESS,
  GROUPS_FETCH_MANY_FAILURE,
  GROUPS_FETCH_REQUEST,
  GROUPS_FETCH_SUCCESS,
  GROUPS_FETCH_FAILURE,
  GROUPS_SAVE_REQUEST,
  GROUPS_SAVE_SUCCESS,
  GROUPS_SAVE_FAILURE,

  EMPTY_GROUPS,
  CLEAR_ERRORS
} from './types'

export default {
  deleteMany ({ commit }, { ids = [] }) {
    commit(GROUPS_BATCH_DELETE_REQUEST)
    return window.axios.post('/groups', { _method: 'DELETE', ids }).then(response => {
      commit(GROUPS_BATCH_DELETE_SUCCESS, response)
      return response
    }).catch(error => {
      commit(GROUPS_BATCH_DELETE_FAILURE, error)
      throw error
    })
  },
  fetchMany ({ commit }, { query = '', page = 1 }) {
    commit(GROUPS_FETCH_MANY_REQUEST)
    return window.axios.get('/groups', { params: { query, page } }).then(response => {
      commit(GROUPS_FETCH_MANY_SUCCESS, response)
      return response
    }).catch(error => {
      commit(GROUPS_FETCH_MANY_FAILURE, error)
      throw error
    })
  },
  fetch ({ commit }, id) {
    commit(GROUPS_FETCH_REQUEST)
    return window.axios.get(`/groups/${id}`).then(response => {
      commit(GROUPS_FETCH_SUCCESS, response)
      return response
    }).catch(error => {
      commit(GROUPS_FETCH_FAILURE, error)
      throw error
    })
  },
  save ({ commit }, group) {
    const path = group.id ? `/groups/${group.id}` : '/groups'
    const method = group.id ? 'put' : 'post'

    commit(GROUPS_SAVE_REQUEST)
    return window.axios[method](path, group).then(response => {
      commit(GROUPS_SAVE_SUCCESS, response)
      return response
    }).catch(error => {
      if (error.response.status === 422) {
        commit(GROUPS_SAVE_FAILURE, { validationErrors: error.response.data })
      } else {
        commit(GROUPS_SAVE_FAILURE, { error })
      }
      throw error
    })
  },
  empty({ commit }) {
    commit(EMPTY_GROUPS);
  },
  clearErrors({ commit }) {
    commit(CLEAR_ERRORS)
  }
}
